const validate = (values, { t }) => {
  const errors = {};
  if (values.communication) {
    errors.communication = {};
    if (!values.communication.title) {
      errors.communication.title = t('validations.required');
    }
  }
  if (!values.calendar) {
    errors.calendar = t('validations.required');
  }
  if (!values.relatedObjects || values.relatedObjects.length < 1) {
    errors.relatedObjects = t('validations.required');
  }

  if (!values.initialHour || !values.finalHour) {
    if (!values.initialHour) {
      errors.initialHour = t('validations.required');
    }
    if (!values.finalHour) {
      errors.finalHour = t('validations.required');
    }
  }

  if (values.start === values.end && values.finalHour) {
    if (values.finalHour <= values.initialHour) {
      errors.finalHour = t('validations.event-end-after-starts');
    }
  }

  return errors;
};
export default validate;
